import React from 'react';
import BaseModalV2 from '../utils/BaseModalV2/BaseModalV2';
import { Content, Text } from './RedirectingModal.styles';
import massPayLogo from '../../../assets/images/massPay.jpeg';

const RedirectingModal = ({ modalRef }) => {
  return (
    <BaseModalV2
      ref={modalRef}
      onClose={() => {
        modalRef.current.hide();
      }}>
      <Content>
        <img src={massPayLogo} alt="massPayLogo" />
        <Text>You're being redirected to another page, it may takes up to 10 seconds.</Text>
      </Content>
    </BaseModalV2>
  );
};

export default RedirectingModal;
